import { render, staticRenderFns } from "./RoomControl.vue?vue&type=template&id=18aa0d96&scoped=true&"
import script from "./RoomControl.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RoomControl.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./RoomControl.vue?vue&type=style&index=0&id=18aa0d96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aa0d96",
  null
  
)

export default component.exports